import DOMPurify from "dompurify";

export const WELCOME_LOGO_HEADER_STYLE = "max-height: 72px; max-width: 240px; object-fit: contain;";

const LOGO_PLACEHOLDER = /\{\{\s*LOGO_URL\s*\}\}/i;

/**
 * @param {string} value
 * @returns {string}
 */
function decodeHtmlAttr(value) {
  return String(value || "")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

/**
 * @param {string} tag
 * @param {string} [logoUrl]
 * @returns {boolean}
 */
function isEmbeddedEmailLogoTag(tag, logoUrl) {
  if (LOGO_PLACEHOLDER.test(tag)) {
    return true;
  }
  const quotedSrc = tag.match(/\bsrc\s*=\s*(["'])([\s\S]*?)\1/i);
  const src = decodeHtmlAttr(quotedSrc ? quotedSrc[2] : "");
  const quotedAlt = tag.match(/\balt\s*=\s*(["'])([\s\S]*?)\1/i);
  const alt = decodeHtmlAttr(quotedAlt ? quotedAlt[2] : "").trim();
  if (logoUrl && src === logoUrl) {
    return true;
  }
  return /^logo$/i.test(alt);
}

/**
 * @param {string} html
 * @param {string} [logoUrl]
 * @returns {string}
 */
export function stripEmbeddedEmailLogoImages(html, logoUrl) {
  if (typeof html !== "string" || html === "") {
    return "";
  }
  const withoutLogos = html.replace(/<img\b[^>]*>/gi, (tag) => (
    isEmbeddedEmailLogoTag(tag, logoUrl) ? "" : tag
  ));
  return withoutLogos.replace(/<div\b[^>]*>\s*<\/div>/gi, "");
}

/**
 * @param {string} html
 * @param {string} logoUrl
 * @returns {number}
 */
export function countEmailLogoImages(html, logoUrl) {
  if (typeof html !== "string" || typeof logoUrl !== "string" || logoUrl === "") {
    return 0;
  }
  const matches = html.match(/<img\b[^>]*>/gi) || [];
  return matches.filter((tag) => isEmbeddedEmailLogoTag(tag, logoUrl)).length;
}

/**
 * @param {string} value
 * @returns {string}
 */
function escapeAttribute(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;");
}

/**
 * @param {{
 *   cuerpo: string,
 *   defaultBody: string,
 *   logoCorreo: string,
 * }} params
 * @returns {string}
 */
export function buildWelcomeEmailPreviewHtml({ cuerpo, defaultBody, logoCorreo }) {
  let html = cuerpo || defaultBody;
  const safeNombre = DOMPurify.sanitize("Juan Pérez");
  const safeLoginUrl = DOMPurify.sanitize("#");
  const safeCursos = DOMPurify.sanitize("<li>Curso de Ejemplo 1</li><li>Curso de Ejemplo 2</li>");

  html = html.replace(/\{\{nombre\}\}/g, safeNombre);
  html = html.replace(/\{\{NOMBRE\}\}/g, safeNombre);
  html = html.replace(/\{\{ENLACE_LOGIN\}\}/gi, safeLoginUrl);
  html = html.replace(/\{\{cursosLista\}\}/g, safeCursos);
  html = html.replace(/\{\{CURSOS_LISTA\}\}/g, safeCursos);
  html = html.replace(/\{\{\s*LOGO_URL\s*\}\}/g, escapeAttribute(logoCorreo));

  html = stripEmbeddedEmailLogoImages(html, logoCorreo);

  if (logoCorreo) {
    const safeLogo = escapeAttribute(logoCorreo);
    html = `<div style="text-align: center; margin-bottom: 24px; padding: 16px 0; border-bottom: 1px solid #e5e7eb;"><img src="${safeLogo}" alt="Logo" style="${WELCOME_LOGO_HEADER_STYLE}"></div>${html}`;
  }

  return DOMPurify.sanitize(html, {
    ADD_ATTR: ["src", "alt", "style", "href", "target"],
  });
}
